import { useCallback, useRef } from 'react';

import { Noop } from '@hsp/utilities';

import { SaveFeatures } from 'types/pages/audience-builder/shared/save';
import { ISaveContext, SaveContextReturnType } from 'types/pages/audience-builder/shared/save/context';

export const useSaveStore = (): SaveContextReturnType => {
  const store = useRef<ISaveContext>({
    features: SaveFeatures.Shop,
    formType: 'basic',
    isOpen: false,
    saveAsMaster: false,
    saveAsPreBuilt: false,
    saveTo: false,
  });

  const subscribers = useRef<Set<Noop>>(new Set());

  const get = useCallback(() => store.current, []);
  const set = useCallback((value: Partial<ISaveContext>) => {
    store.current = { ...store.current, ...value };
    subscribers.current.forEach((callback) => callback());
  }, []);
  const subscribe = useCallback((callback: Noop) => {
    subscribers.current.add(callback);

    return () => {
      subscribers.current.delete(callback);
    };
  }, []);

  return {
    get,
    set,
    subscribe,
  };
};
